import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';

class GRBlockGrantsDetailedBill extends React.Component {
  render() {
    const { bill, } = this.props;

    const items = VerticalLabelList.toList(bill, {
      displayFormatter: (value) => {
        const formattedValue = value.split('_').join(' ');
        return _.startCase(formattedValue);
      },
    });
    return (
      <FieldSet title="Bill Summary" style={{ height: '100%', fontSize: '20px', }}>
        <VerticalLabelList items={items} exclusions={this.keyExclusions} />
      </FieldSet>
    );
  }
}

GRBlockGrantsDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default GRBlockGrantsDetailedBill;
